import { PageHero, SectionHeading } from "@/components/Section";
import OrderingShowcase from "@/components/home/OrderingShowcase";
import { motion } from "framer-motion";
import { stagger, fadeUp } from "@/components/Reveal";
import { PortalButton } from "@/components/PortalButton";
import { Clock, RotateCcw, Star, Tag, Activity, History, FileCheck2, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: Clock, t: "Order 24/7", d: "Place orders any time from phone or computer." },
  { icon: RotateCcw, t: "Quick Reorder", d: "Repeat previous purchases in a couple of taps." },
  { icon: Star, t: "Saved Products", d: "Favourite the items you order most." },
  { icon: Tag, t: "Your Pricing", d: "See customer-specific wholesale pricing." },
  { icon: Activity, t: "Track Status", d: "Follow orders from prepared to delivered." },
  { icon: History, t: "Order History", d: "Every order stored and searchable." },
  { icon: FileCheck2, t: "Digital Confirmations", d: "Instant confirmations for every order." },
  { icon: ShieldCheck, t: "Fewer Errors", d: "Structured ordering reduces mistakes." },
];

export default function OnlineOrdering() {
  return (
    <>
      <PageHero
        chapter="Online Ordering"
        title="Order restaurant supplies without the back-and-forth"
        lead="Browse available products, view your pricing, select quantities, choose a delivery date and submit your order — all from one modern platform."
      >
        <PortalButton variant="butter" testId="ordering-page-access-btn">Request Online Access</PortalButton>
      </PageHero>

      <OrderingShowcase />

      <section className="py-24 md:py-32 bg-cream">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10">
          <SectionHeading chapter="Platform Benefits" overline="Built for Busy Kitchens" title="Everything you need to order faster" className="mb-14" />
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {FEATURES.map(({ icon: Icon, t, d }) => (
              <motion.div key={t} variants={fadeUp} className="rounded-3xl border border-forest/15 bg-white p-6">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-butter text-forest mb-4"><Icon className="h-5 w-5" /></span>
                <h3 className="font-display text-lg text-forest">{t}</h3>
                <p className="text-sm text-forest/70 mt-1.5 leading-relaxed">{d}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}
